import React from "react";
import { Drawer as AntDrawer } from "./AntDrawer";
import { useScrollDrawerIntoView } from "./useScrollDrawerIntoView";

/**
 * ScrollDrawer behaves exactly like the base Drawer but ensures that when the
 * drawer becomes visible it is scrolled into the middle of the viewport so the
 * user always sees the header immediately.
 *
 * All props accepted by the base Drawer are forwarded.
 */
export function ScrollDrawer(
  props: React.ComponentProps<typeof AntDrawer>,
) {
  const { open=false, ...rest } = props;
  const wrapperRef = useScrollDrawerIntoView(open);
  return (
    <div ref={wrapperRef}>
      <AntDrawer open={open}  {...(rest)} />
    </div>
  );
}
